import { Button } from '@patternfly/react-core'
import styled from 'styled-components'

export const SmallButton = styled(Button)`
  font-size: 0.7rem;
  padding: 0.275rem 0.65rem;
`
